<template>
  <section class="team">
      <div class="team__content container">
        <h2 class="team__headtitle --fade-in-up" data-vertical-ivp-class="--animate">An experienced team</h2>
        <h1 class="team__title --fade-in-up" data-vertical-ivp-class="--animate">
          Just like our warranties, we have you covered. 
        </h1>

        <hr class="team__line --fade-in-up" data-vertical-ivp-class="--animate">

        <div class="--fade-in-up --delay-1" data-vertical-ivp-class="--animate">
          <h3 class="team__title-description">
            Frank Hawley, Director and Chief Executive Officer of MHHC Enterprises, Inc.
          </h3>
          <p class="team__description">
            • 	Brings years of executive leadership experience to his role as CEO of MHHC Enterprises, Inc. <br>
            • 	Formerly served as Policy and Budget Manager and Licensing Division Manager for the State of Washington. <br>
            • 	For the state, he oversaw multi-million-dollar operating budgets, and led a team focused on compliance,
            licensing, and policy issues while also promoting business initiatives. <br>
            • 	Also held a corporate management career at AT&T and was in involved in sales, marketing, engineering, and operations. <br>
            • 	Currently, he leads the growth and development of MHHC Enterprises, Inc., and its subsidiaries.
          </p>
          <h3 class="team__title-description">
            Raymond MacKay, Director and Chief Executive Officer of MHHC Reinsurance, Inc.
          </h3>
          <p class="team__description">
            • 	Graduated from Furman University and from the University of South Carolina Law School with a Juris Doctorate degree. <br>
            • 	Has worked primarily as a sole practitioner focused on trial and corporate work in Anderson, SC. <br>
            • 	Also served as Assistant Solicitor for the Tenth Judicial Circuit of SC and as a Municipal Court Judge for the city of Anderson, SC. <br>
            • 	Has served on the Board of Directors for MHHC Enterprises since 2018 and has overseen the company's expansion into
                additional state jurisdictions and the development of its regulatory compliance system. <br>
            • 	Now holds the role of CEO of MHHC Reinsurance, Inc., bringing valuable leadership and legal experience to the subsidiary. <br>
          </p>
          <h3 class="team__title-description">
            Anderson Salgado, Chief Executive Officer of  ONBLi
          </h3>
          <p class="team__description">
            Anderson Salgado is an accomplished e-Commerce expert who in the past five years has made a
            name for himself based on having keen insight into the Amazon Marketplace. Anderson, a U.S.
            Marine Corps Veteran who served in Operations Enduring Freedom in 2011-12 is also a University
            of Miami MBA Graduate, former Amazon Senior Vendor/General Manager for the Beauty and Professional
            Beauty Categories, and has been featured in Bloomberg and Business Insider magazines as a
            Subject Matter Expert (SME) in Amazon advertising, optimization, and growth hacking after being
            instrumental in developing the Pro and Luxury Beauty category at Amazon (one of the fastest-growing
            categories of the platform since 2016) and later launching his own agency to help other brands to do the same. 
          </p>
        </div>
        <div class="team__buttons --fade-in-up" data-vertical-ivp-class="--animate">
          <a href="https://mhhc.app.dealmaker.tech/invitations/c9a88252-39be-4be8-a114-1718712d60b7/view"
          target="_blank">
            <button class="button">
              Invest Now
            </button>
          </a>
          <a href="https://www.sec.gov/Archives/edgar/data/1826135/000152013822000450/mhhc_1sa.htm"
          target="_blank">
            <button class="button">
              READ OFFERING CIRCULAR
            </button>
          </a>
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Team',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/team.scss";
</style>
